import { Controller } from "stimulus"

export default class extends Controller
  @targets = ['sourceHiddenField', 'hoursField', 'minutesField']
  
  refresh: ->
    hoursToMinutes = parseInt(@hoursFieldTarget.value) * 60
    minutes = parseInt(@minutesFieldTarget.value)
    
    @sourceHiddenFieldTarget.value = (hoursToMinutes or 0) + (minutes or 0)